import React, { useEffect, useState } from 'react'

import {
    useNavigate
  } from "react-router-dom";

import { useDispatch, useSelector } from 'react-redux'

import {Card, CardActions, CardContent, CardMedia, Button, Typography, CircularProgress, Box} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SportsFootballIcon from '@mui/icons-material/SportsFootball';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'

import Moment from 'moment'

import useStyles from './styles.js'

import avatar from '../../../images/match_rugby.png'
import avatar_soccer from '../../../images/match_football.png'
import avatar_handball from '../../../images/match_handball.png'
import MatchPopupCreator from '../form/popup/MatchPopupCreator.js';
import { createMatch, updateMatch, deleteMatch } from '../../../actions/matchs.js';
import { isFeuilleDeMatchFull } from '../../Live/utils/feuilleMatch.js';
import { isAdminUser } from '../../../actions/auth.js';

const Match = ({ match, setCurrentId , reload}) => {

    const classes = useStyles();

    /*const initialMatchData = {
        season : '',
        competition : match.competition,
        season : '',
        day : match.day,
        dateTime : match.dateTime,
        homeTeam : match.homeTeam,
        awayTeam : match.awayTeam,
        homeComposition : '',
        homeHolders : [],
        homeSubstitutes : [],
        awayComposition : '',
        awayHolders : [],
        awaySubstitutes : [],
    }*/

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const homeTeam = useSelector((state) => state.teams.find(t => match.homeTeam === t._id))
    const awayTeam = useSelector((state) => state.teams.find(t => match.awayTeam === t._id))
    const competition = useSelector((state) => state.competitions.find(c => match.competition === c._id))

    // Le match data par défaut
    const getInitialMatchData = () => {
      let initialMatchData = {
        competition : match.competition,
        season : '',
        day : match.day,
        dateTime : match.dateTime,
        homeTeam : match.homeTeam,
        homeSubstitutes : [{}, {},{}, {}, {}],
  
        awayTeam : match.awayTeam,
        awaySubstitutes : [{}, {},{}, {}, {}],

        provider : match.provider
      }

      return ({...initialMatchData, ...getInitialMatchComp()})

    }

    // On split la constituion de la compo et on considère un cas de competition nulle
    const getInitialMatchComp = () => {

      let initialMatchData = {}

      if(!competition || competition.discipline === 'soccer'){
        initialMatchData.homeHolders = []
        initialMatchData.awayHolders = []
        initialMatchData.homeComposition = '442'
        initialMatchData.awayComposition = '442'
      }else if(competition && competition.discipline === 'rugby'){
        initialMatchData.homeHolders = []
        initialMatchData.awayHolders = []
        initialMatchData.homeComposition = 'rugby15'
        initialMatchData.awayComposition = 'rugby15'
      }else if(competition && competition.discipline === 'basket'){
        initialMatchData.homeHolders = []
        initialMatchData.awayHolders = []
        initialMatchData.homeComposition = 'basket5'
        initialMatchData.awayComposition = 'basket5'
      }else if(competition && competition.discipline === 'handball'){
        initialMatchData.homeHolders = []
        initialMatchData.awayHolders = []
        initialMatchData.homeComposition = 'handball7'
        initialMatchData.awayComposition = 'handball7'
      }

      return initialMatchData
    }

    // Permet de mettre à jour la compo une fois la competition chargée
    useEffect(() => {

      let initialMatchData = getInitialMatchComp()

      if(!competition || competition.discipline === 'soccer'){
        initialMatchData.homeHolders = []
        initialMatchData.awayHolders = []
        initialMatchData.homeComposition = '442'
        initialMatchData.awayComposition = '442'
      }else if(competition && competition.discipline === 'rugby'){
        initialMatchData.homeHolders = []
        initialMatchData.awayHolders = []
        initialMatchData.homeComposition = 'rugby15'
        initialMatchData.awayComposition = 'rugby15'
      }else if(competition && competition.discipline === 'basket'){
        initialMatchData.homeHolders = []
        initialMatchData.awayHolders = []
        initialMatchData.homeComposition = 'basket15'
        initialMatchData.awayComposition = 'basket15'
      }else if(competition && competition.discipline === 'handball'){
        initialMatchData.homeHolders = []
        initialMatchData.awayHolders = []
        initialMatchData.homeComposition = 'handball7'
        initialMatchData.awayComposition = 'handball7'
      }

      setStepInfos(s => ({...s, data : {...s.data, ...initialMatchData}}))
    }, [competition])


    const [open, setOpen] = useState(false);
    const [stepInfos, setStepInfos] = React.useState(
      { data : getInitialMatchData(),  isComplete : [false, false, false]}
    )

    const handleClickOpen = () => {
        setOpen(true);
      };
    
    const handleClose = () => {
      setOpen(false);
    };

    const handleConfirm = () => {
      // On veut sauvegarder le match dans son état
      dispatch(updateMatch(match._id, stepInfos.data))

      handleClose()
    }

    const handleCancel = () => {
      setOpen(false);
      setStepInfos({ data : getInitialMatchData(), isComplete : [false, false, false]})
    }

    const getAvatar = () => {

      switch (match.discipline) {
        case 'soccer':
          return avatar_soccer;
        case 'rugby':
          return avatar;
        case 'handball':
          return avatar_handball;
        default: return;
    }
  }

    return (
        homeTeam && awayTeam && competition ? (
            <><Card className={classes.card}>

                                                        <CardMedia className={classes.media} image={match.photo || getAvatar()} title={"Match"} sx={{backgroundColor : 'rgba(0,0,0,0)'}}/>

                                                        <div className={classes.details}>
                                                            <Typography variant="body2" color="textSecondary">{new Date(match.dateTime).toLocaleString()}</Typography>
                                                        </div>
                                                        {/*!isFeuilleDeMatchFull(match) && <Box sx={{textAlign : 'center'}}>
                                                          <Button size="small" color="primary" variant={'contained'} onClick={handleClickOpen} sx={{width : '70%'}}>
                                                                  Saisir feuille du match
                                                          </Button>
                                                        </Box>*/}

                                                            {isAdminUser && <Button size="small" color="secondary" onClick={() => navigate(`/matchmanagement/${match._id}`)}>
                                                                <AdminPanelSettingsIcon fontSize="small"/>
                                                                Admin
                                                            </Button>}
                                                        
                                                        <CardContent>
                                                        
                                                            <Typography className={classes.title} variant="h6" gutterBottom>{homeTeam.name} - {awayTeam.name}</Typography>
                                                            <Typography className={classes.title} variant="h7" gutterBottom>{competition.name}</Typography>
                                                            
                                                        </CardContent>

                                                        <CardActions className={classes.cardActions}>
                                                            {isAdminUser && <Button size="small" color="primary" onClick={() => {dispatch(deleteMatch(match._id)); reload()}}>
                                                                <DeleteIcon fontSize="small"/>
                                                                Supprimer
                                                            </Button>}

                                                            <Button size="small" color="primary" onClick={() => navigate(`/match/${match._id}`)}>
                                                            {match.discipline === 'soccer' || match.discipline === 'handball' ? <SportsSoccerIcon fontSize="small"/>:<SportsFootballIcon fontSize="small"/>} Saisir des données
                                                            </Button>
                                                        </CardActions>
                                                    </Card><MatchPopupCreator 
                  open={open} 
                  setOpen={setOpen}
                  handleConfirm={handleConfirm}
                  handleCancel={handleCancel}
                  stepInfos={stepInfos} 
                  setStepInfos={setStepInfos}/></>) 
                                                    : <CircularProgress />
        )
    
}

export default Match